import { isProduction } from '@/common/infrastructure/config/env';

export interface TidOptionProps {
  id?: string;
  cls?: string | Array<string>;
  vals?: { [key: string]: string };
}

interface HTMLTagAttributeProps {
  [key: string]: string;
}

export const TID_ATTR = 'data-testid';

/**
 * Produces a Destructurable Object of Data-Attributes for use as
 * Selectors in E2E and Unit Testing Elements.
 * @param {string|options} idOrOptions - an Id or TidOptionProps Object
 * @returns object with keys and values
 */
export const tid = (idOrOptions: string | TidOptionProps): HTMLTagAttributeProps => {
  // Don't create Test Attributes if in Production Mode
  if (isProduction()) return {};

  // As String
  if (typeof idOrOptions === 'string') return { [TID_ATTR]: idOrOptions };

  // As Options
  const options = idOrOptions;

  // Return Attributes in Destructurable Object
  return {
    ...(options?.id ? { [TID_ATTR]: options.id } : {}),
    ...(options?.cls ? { 'data-test-class': [options.cls].flat().join(' ') } : {}),
    ...(options?.vals ? Object.entries(options.vals).reduce((acc, [key, val]) => ({ ...acc, [`data-test-${key}`]: val }), {}) : {})
  };
};

export default tid;
